import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"noodle"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M21 12V11H3V12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M16 4L17 4M17 4H20M17 4V10M20 4H21M20 4V10M4 10C4 7.23858 6.23858 5 9 5C11.7614 5 14 7.23858 14 10V11H4L4 10ZM7 10C7 8.89543 7.89543 8 9 8C10.1046 8 11 8.89543 11 10V11H7V10Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M21 12V11H3V12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Noodle = Vue.extend<IconProps>({
  name: 'NoodleIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'noodle',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Noodle;
